<template>
  <div id="printForm">
    <printer title="Personal Reflection Assignment">
      <template v-slot:printContent>
        <div>
          <h5 class="font-weight-bold">
            Personal Reflection Assignment
          </h5>
          <p>
            An important focus of the upcoming Wood badge course will be a consideration of our roles as leaders in Scouting, in the workplace, in our communities, and in the nation.  Among the most valuable discussions that will occur will be an ongoing consideration of setting leadership goals and then determining the way these goals can be reached.
          </p>
          <p>
            This pre-course assignment is intended to help you lay the groundwork for the course by developing a clearer understanding of your personal interests, values, and sense of the future.  At Wood Badge, you will have the opportunity to channel that information into the development of specific goals and effective means of action.
          </p>
          <p>
            <ul>
              <li>This assignment is for you to do on your own</li>
              <li>No one except you will see the results of this assignment</li>
            </ul>
          </p>
          <p>
            Use this opportunity to take a good look at where you are now in terms of interests, leadership skills, and opportunities, and where you would like to be.  Be as honest as you can.  Enjoy the experience.
          </p>
          <h5 class="font-weight-bold">
            What to do:
          </h5>
          <p>
            <ul>
              <li>Set aside time to think seriously about the following questions.  Answer the questions as fully and honestly as you can.</li>
              <li>Write down your answers and bring them to the Wood Badge course.  You will find them to be a helpful reference - only you will see the answers.</li>
              <li>Don't worry about what the "right" answers are or about satisfying someone else's idea of how you should respond.  No one except you will see what you write.</li>
            </ul>
          </p>
        </div>
        <card>
          <div class="form-group">
            <label for="strengths">1. What are my top three strengths as a leader?  How can I apply these skills or talents so that I could be of service to youth in my unit, district, or council?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.TopThreeSkills }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="growth">2. What do I consider my top three growth opportunities for my leadership abilities?  How can I improve in these areas while serving in my current role?  Are there other trainings or classes I can take to improve on myself?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.TopThreeGrowth }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="impactfulExperience">3. What is my most impactful experience so far in Scouting?  Thinking about this experience, is there a way I could allow others to have the same experience?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.ImpactfulExperience }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="qualitiesOfCharacter">4. What qualities of character do I most admire in those I view as strong leaders?  Do I have these qualities?  Is there anything in my approach I could change to help me become a strongler leader?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.QualitiesofCharacter }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="leaderImpactedMe">5. Who is a leader that has significantly impacted my life, and why?  In my Scouting role, can I make the same impact?  How would I do it?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.LeaderImpactedMe }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="scoutingImprovements">6. If there were no barriers, what improvements would I see made in my local Scouting program?  Is there anything I could do to effect that change or have a role in those improvements?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.ScoutingImprovements }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="importantLifeRoles">7. What do I consider to by my most important roles in life (e.g. parent, mentor)?  Are any of these roles something i can improve in tandem with Scouting?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.ImportantLifeRoles }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="meInTwoYears">8. In two years, what role do I see myself in Scouting?  What is one thing I could do to help myself get there?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.MeInTwoYears }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="differenceInOneLife">9. If I could make a difference in just on child's likfe, what would I do?  If I can impact one child, can I lead others to impact many children?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.DifferenceInOneLife }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="diversity">10. When I think of "diversity and inclusiveness," what do I think of?  Does my Scouting unit, district, or council practice this type of inclusiveness?  Is there anything I could do to increase the practice of inclusiveness?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.Diversity }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="lessEffectiveExperience">11. What Scouting experience have I had that I should have handled differently?  What could I have done differently?  How can I change my current approach or prepare others to handle this type of thing better?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.LessEffectiveExperience }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="hopeForYouth">12. What do I hope the youth will gain by participating in Scouting?  Am I doing things now to help Scouts gain what I envision they will achieve?  If not, how could I?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.HopeForYouth }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="myRoleSupportScouting">13. How does my current role support the Scouting movement?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.MyRoleSupportScouting }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="topThreePersonalValues">14. What are my top three personal values?  How have my core values been shaped throughout my life?  What could I do to also help shape the core values of the youth/adults I work with?  If working with adults, how could I lead diffferently, in a way that more mimics my core values?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.TopThreePersonalValues }}
            </div>
          </div>
        </card>
        <card>
          <div class="form-group">
            <label for="achieveByTakingWoodBadge">15. What do I hope to acheive by taking Wood Badge?</label>
            <div
              class="form-control printValue"
              id="strengths"
            >
              {{ pca.AchieveByTakingWoodBadge }}
            </div>
          </div>
        </card>
      </template>
    </printer>
  </div>
</template>

<script>
import Printer from '@/components/_main/printer.vue'

export default {
  name: 'PrecourseAssignmentPrint',
  components: {
    Printer
  },
  props: {
    pca: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  p {
    padding-left: 20px;
  }
  p ul {
    padding-left: 20px;
  }
</style>
